export const ROUTES = {
  LOGIN: {
    key: 'login',
    path: '/login',
  },
  SIGN_UP: {
    key: 'sign-up',
    path: '/sign-up',
  },
  CONFIRM_EMAIL: {
    key: 'confirm-email',
    path: '/sign-up/confirm-email',
  },
  CONFIRM_PHONE: {
    key: 'confirm-phone',
    path: '/sign-up/confirm-phone',
  },
  TWO_FACTOR: {
    key: 'two-factor',
    path: '/two-factor',
  },
  RESET_PASSWORD: {
    key: 'reset-password',
    path: '/reset-password'
  },
  RESET_PASSWORD_SUCCESS: {
    key: 'reset-password-success',
    path: '/reset-password/success',
  },
  RESET_PASSWORD_ERROR: {
    key: 'reset-password-error',
    path: '/reset-password/error',
  },
  RESET_PASSWORD_CONFIRM: {
    key: 'reset-password-confirm',
    path: '/auth/password/:token',
  },
  DASHBOARD: {
    key: 'dashboard',
    path: '/dashboard',
  },
  ACCOUNT: {
    key: 'account',
    path: '/account/:id',
  },
  TOP_UP: {
    key: 'top-up',
    path: '/top-up',
  },
  GET_VIRTUAL_CARD: {
    key: 'get-virtual-card',
    path: '/get-virtual-card',
  },
  GET_PLASTIC_CARD: {
    key: 'get-plastic-card',
    path: '/get-plastic-card',
  },
  BLOCK_CARD: {
    key: 'block-card',
    path: '/block-card',
  },
  CARD: {
    key: 'card',
    path: '/card',
  },
  CARD_3DS: {
    key: 'card-3ds',
    path: '/card-3ds',
  },
  NOTIFICATIONS: {
    key: 'notifications',
    path: '/notifications',
  },
  DELETE_ACCOUNT: {
    key: 'delete-account',
    path: '/delete-account',
  },
  STATEMENT: {
    key: 'statement',
    path: '/statement',
  },
  VERIFICATION: {
    key: 'verification',
    path: '/verification',
  },
  PROFILE: {
    key: 'profile',
    path: '/profile',
  },
  CHANGE_EMAIL: {
    key: 'change-email',
    path: '/change-email',
  },
  CHANGE_PHONE: {
    key: 'change-phone',
    path: '/change-phone',
  },
  CHANGE_PASSWORD: {
    key: 'change-password',
    path: '/change-password',
  },
} as const;
